import React from 'react';
import { motion } from 'framer-motion';
const SERVICES = [{
  title: 'Event Planning',
  description: 'Custom support for birthdays, showers, weddings, private celebrations, vendor events, and corporate gatherings.',
  image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2069&auto=format&fit=crop'
}, {
  title: 'Event Design & Styling',
  description: 'Theme development, color coordination, layout planning, décor styling, and visual presentation.',
  image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=2074&auto=format&fit=crop'
}, {
  title: 'Event Rentals',
  description: 'Tables, chairs, linens, backdrops, balloon décor, props, signage, displays, and specialty rental items.',
  image: 'https://cdn.magicpatterns.com/uploads/7iWNcCU7wRDB1E28Mowzox/pexels-urfriendlyphotog-28937190.jpg'
}, {
  title: 'Setup & Breakdown',
  description: 'Delivery, setup, styling, and post-event breakdown for a smoother event experience.',
  image: 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?q=80&w=2162&auto=format&fit=crop'
}];
export function RentalAssortment() {
  return <section className="py-14 bg-white" data-id="element-122">
      <div className="mx-4 md:mx-[4.1rem]" data-id="element-123">
        <div className="max-w-[1440px] mx-auto px-6" data-id="element-124">
          <div className="text-center mb-16" data-id="element-125">
            <h2 className="font-serif text-4xl md:text-5xl mb-6 text-gray-900" data-id="element-126">
              Services Assortment
            </h2>
            <p className="text-gray-500 max-w-3xl mx-auto text-lg leading-relaxed" data-id="element-127">
              From meticulous planning to exquisite design and seamless
              execution, we offer a comprehensive range of services to bring
              your vision to life.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-128">
            {SERVICES.map((service, index) => <motion.div key={service.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group cursor-pointer" data-id="element-129">
                <div className="relative h-[200px] overflow-hidden mb-6" data-id="element-130">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-131" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" data-id="element-132" />
                </div>
                <div className="text-center px-2" data-id="element-133">
                  <h3 className="text-xl font-serif text-gray-900 group-hover:text-[#b22222] transition-colors mb-3" data-id="element-134">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed" data-id="element-135">
                    {service.description}
                  </p>
                  <div className="w-8 h-[1px] bg-gray-300 group-hover:w-16 group-hover:bg-[#b22222] transition-all duration-500 mx-auto mt-6" data-id="element-136" />
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}